export enum MaterialMutationTypes {
  SET_MATERIAL_SOURCE_PAGE = 'SET_MATERIAL_SOURCE_PAGE'
}
